module.exports = __webpack_public_path__ + "static/media/decrease.bd186d47.svg";